function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: o-HelveticaNeue, Arial, sans-serif;\n  font-weight: 700;\n  font-size: ", ";\n  line-height: ", ";\n  border-style: solid;\n  border-width: ", ";\n  border-color: ", ";\n\n  background-color: ", ";\n\n  color: ", ";\n    \n  padding: ", ";\n  height: ", ";\n  max-width: ", ";\n  vertical-align: middle;\n  overflow: hidden;\n  transition: border-color .2s ease-in-out, background-color .2s ease-in-out, color .2s ease-in-out;\n  user-select: none;\n\n  &:not(:disabled) {\n    cursor: pointer;\n  }\n\n  &:hover,\n  &:focus {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:active {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n\n    background-color: ", ";\n\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { px2rem, padding } from '../Utils/helpers';
import { button } from '../../styles/variables';
var StyledButton = styled('button')(_templateObject(), px2rem(button.common.fontSize), px2rem(button.common.lineHeight), px2rem(button.common.borderWidth), function (_ref) {
  var variant = _ref.variant,
      inverse = _ref.inverse,
      loading = _ref.loading;
  return button[variant][inverse ? 'inverse' : 'normal'][loading ? 'loading' : 'default'].borderColor;
}, function (_ref2) {
  var variant = _ref2.variant,
      inverse = _ref2.inverse,
      loading = _ref2.loading;
  return button[variant][inverse ? 'inverse' : 'normal'][loading ? 'loading' : 'default'].backgroundColor;
}, function (_ref3) {
  var variant = _ref3.variant,
      inverse = _ref3.inverse,
      loading = _ref3.loading;
  return button[variant][inverse ? 'inverse' : 'normal'][loading ? 'loading' : 'default'].color;
}, padding(button.common), function (_ref4) {
  var tall = _ref4.tall;
  return tall ? px2rem(button.common.paddingTop + button.common.paddingBottom + button.common.lineHeight * 2 + button.common.borderWidth * 2) : undefined;
}, px2rem(button.common.maxWidth), function (_ref5) {
  var variant = _ref5.variant,
      inverse = _ref5.inverse;
  return button[variant][inverse ? 'inverse' : 'normal'].hover.borderColor;
}, function (_ref6) {
  var variant = _ref6.variant,
      inverse = _ref6.inverse;
  return button[variant][inverse ? 'inverse' : 'normal'].hover.backgroundColor;
}, function (_ref7) {
  var variant = _ref7.variant,
      inverse = _ref7.inverse;
  return button[variant][inverse ? 'inverse' : 'normal'].hover.color;
}, function (_ref8) {
  var variant = _ref8.variant,
      inverse = _ref8.inverse;
  return button[variant][inverse ? 'inverse' : 'normal'].active.borderColor;
}, function (_ref9) {
  var variant = _ref9.variant,
      inverse = _ref9.inverse;
  return button[variant][inverse ? 'inverse' : 'normal'].active.backgroundColor;
}, function (_ref10) {
  var variant = _ref10.variant,
      inverse = _ref10.inverse;
  return button[variant][inverse ? 'inverse' : 'normal'].active.color;
}, function (_ref11) {
  var variant = _ref11.variant,
      inverse = _ref11.inverse,
      loading = _ref11.loading;
  return button[variant][inverse ? 'inverse' : 'normal'][loading ? 'loading' : 'disabled'].borderColor;
}, function (_ref12) {
  var variant = _ref12.variant,
      inverse = _ref12.inverse,
      loading = _ref12.loading;
  return button[variant][inverse ? 'inverse' : 'normal'][loading ? 'loading' : 'disabled'].backgroundColor;
}, function (_ref13) {
  var variant = _ref13.variant,
      inverse = _ref13.inverse,
      loading = _ref13.loading;
  return button[variant][inverse ? 'inverse' : 'normal'][loading ? 'loading' : 'disabled'].color;
});

function Button(props) {
  var children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["children"]);

  return React.createElement(StyledButton, rest, children);
}

Button.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'image']),
  inverse: PropTypes.bool,
  tall: PropTypes.bool,
  loading: PropTypes.bool
} : {};
Button.defaultProps = {
  variant: 'primary',
  inverse: false,
  tall: false,
  loading: false
};
export default Button;